module.exports = __webpack_public_path__ + "8bd2ff19f157649d458cedd25188ae1a.svg";